import React from 'react';
import { FaInstagram, FaEnvelope, FaPhone, FaArrowUp } from 'react-icons/fa';
import './Footer.css';

const Footer = ({ division = 'software' }) => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="footer">
      <div className="footer__container">
        <div className="footer__top">
          <div className="footer__brand">
            <div className="footer__logo">
              <span className="footer__logo-kat">KAT</span>
              <span className="footer__logo-99">99</span>
            </div>
            <p className="footer__tagline">
              {division === 'software'
                ? 'KAT99 Pvt Ltd — Building software that powers businesses across Sri Lanka.'
                : 'KAT99 Construction — Woodworks, renovations and full-scale building projects.'}
            </p>
            <div className="footer__socials">
              <a
                href="https://instagram.com/kat99_pvt_ltd"
                target="_blank"
                rel="noopener noreferrer"
                className="footer__social"
                aria-label="Instagram"
              >
                <FaInstagram />
              </a>
              <a href="mailto:kat99pvtltd@gmail.com" className="footer__social" aria-label="Email">
                <FaEnvelope />
              </a>
              <a href="tel:+94761202374" className="footer__social" aria-label="Phone">
                <FaPhone />
              </a>
            </div>
          </div>

          {division === 'software' ? (
            <div className="footer__links-group">
              <h4>Our Services</h4>
              <a href="#tech">Mobile Apps</a>
              <a href="#tech">Web Applications</a>
              <a href="#tech">Custom Software</a>
              <a href="#tech">UI/UX Design</a>
              <a href="#tech">POS Systems</a>
              <a href="#tech">E-Commerce</a>
            </div>
          ) : (
            <div className="footer__links-group">
              <h4>Construction Services</h4>
              <a href="#construction">Custom Woodworks</a>
              <a href="#construction">Renovations</a>
              <a href="#construction">Full Construction</a>
              <a href="#construction">Interior Design</a>
            </div>
          )}

          <div className="footer__links-group">
            <h4>Company</h4>
            <a href="#about">About Us</a>
            <a href="#projects">Projects</a>
            <a href="#contact">Contact</a>
          </div>
        </div>

        <div className="footer__divider" />

        <div className="footer__bottom">
          <p>
            &copy; {new Date().getFullYear()} KAT99 Pvt Ltd. All rights reserved.
          </p>
          <p className="footer__location">
            Made with passion in Sri Lanka
          </p>
          <button className="footer__back-top" onClick={scrollToTop} aria-label="Back to top">
            <FaArrowUp />
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
